import { render, staticRenderFns } from "./WrongItemReceived.vue?vue&type=template&id=3e66b04a&scoped=true"
import script from "./WrongItemReceived.vue?vue&type=script&lang=js"
export * from "./WrongItemReceived.vue?vue&type=script&lang=js"
import style0 from "./WrongItemReceived.vue?vue&type=style&index=0&id=3e66b04a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e66b04a",
  null
  
)

export default component.exports